module.exports = __webpack_public_path__ + "static/img/scrl.d810bd0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/scrl.png
// module id = SWER
// module chunks = 1